import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SparkoLogo } from "../SparkoLogo";

export const Loader = () => {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setDone(true), 1500);
    return () => clearTimeout(timer);
  }, []);
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          exit={{ y: "-100%" }} transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] grid place-items-center bg-navy" data-testid="page-loader"
        >
          <div className="flex flex-col items-center gap-6">
            <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.6 }}>
              <SparkoLogo dark={false} size={44} tagline />
            </motion.div>
            <div className="h-[3px] w-40 overflow-hidden rounded-full bg-white/15">
              <motion.div initial={{ x: "-100%" }} animate={{ x: "0%" }} transition={{ duration: 1.3, ease: "easeInOut" }} className="h-full w-full bg-blue" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
